"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
require("./PaymentSymbolPagSeguro.scss");
const logo_PagSeguro_webp_1 = __importDefault(require("../../assets/images/logo_PagSeguro.webp"));
const textPaymentSymbolPagSeguro = "O pagamento é processado diretamente pela PagSeguro e os dados do pagamento não ficam armazenados em nosso site.";
const PaymentSymbolPagSeguro = () => (react_1.default.createElement("div", { className: "PaymentSymbolPagSeguro" },
    react_1.default.createElement(antd_1.Tooltip, { className: "tooltip-container", title: textPaymentSymbolPagSeguro },
        react_1.default.createElement("div", { className: "description-container" }, "Pagamento processado pelo"),
        react_1.default.createElement("div", null,
            react_1.default.createElement("img", { src: logo_PagSeguro_webp_1.default })))));
exports.default = PaymentSymbolPagSeguro;
